<template>
  <span v-if="notificationCount" class="notification-count">{{ notificationCount }}</span>
</template>

<script>
/*
Powers the unread notification count in User Nav dropdown
*/

// @flow
import { mapState } from 'vuex'

export default {
  name: 'NotificationCount',
  props: {},
  data() {
    return {}
  },

  computed: {
    ...mapState(['user']),

    notificationCount() {
      if (this.user && this.user.notificationCount && this.user.notificationCount >= 0) {
        return this.user.notificationCount >= 99 ? '99+' : this.user.notificationCount
      }

      return ''
    },
  },
}
</script>
